export const ADD_DOCUMENT_DATA = 'ADD_DOCUMENT_DATA'
export const REMOVE_DOCUMENT_DATA = 'REMOVE_DOCUMENT_DATA'
export const ADD_MESSAGE_DATA = 'ADD_MESSAGE_DATA'
export const REMOVE_MESSAGE_DATA = 'REMOVE_MESSAGE_DATA'
export const ADD_ORDER_DATA = 'ADD_ORDER_DATA'
export const REMOVE_ORDER_DATA = 'REMOVE_ORDER_DATA'
